/** @module csi/slicer/slicerStoreExportController */
define([
	"dojo/_base/declare",
	"csi/action/DownloadController"
], function(declare,DownloadController) {

	/** 
	 * This controller serving action "Export" at "Setup/Service/SlicerStores"
	 * Request defined in "Modules/SiteAdmin/SiteAdmin.xml" (search for "slicerStoreExportController")
	 * Slicer Server API documentation: https://centric8.atlassian.net/wiki/spaces/DEV/pages/171573303/Slicer+Server+API  
	 */
	
	return declare(DownloadController, {
		/**
		 * Add parameter for store name
		 */
		onDownloadRequest: function(request) {
			request.addParameter("Name", this.getNode().$Name);
		}
	});
});